var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ripple",class:_vm.black ? 'black' : 'white',attrs:{"id":"loading_main"}},[_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }